<template>
  <v-container fluid>
    <v-container class="d-flex justify-space-between align-center" fluid>
      최종 갱신: {{ updatedAt.toLocaleString() }}
      <v-spacer></v-spacer>
      <v-btn icon @click="fetchDevices"><v-icon>mdi-refresh</v-icon></v-btn>
    </v-container>

    <v-row>
      <v-col cols="12" sm="6">
        <v-autocomplete
          v-model="customFilters.group"
          :items="groups"
          label="노선"
          hide-details
          clearable
          outlined
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="customFilters.plateNo"
          label="차량번호"
          hide-details
          clearable
          outlined
        ></v-text-field>
      </v-col>
    </v-row>

    <v-data-table
      :items="items"
      :loading="loading"
      :headers="headers"
      :search="search"
      :custom-filter="customFilter"
      class="text-no-wrap"
    >
      <template v-slot:item.fuelType="{ item }">
        <fueltype-chip :fueltype="item.fuelType"></fueltype-chip>
      </template>
      <template v-slot:item.plateNo="{ item }">
        <a @click="showParams(item)">{{ item.plateNo }}</a>
      </template>
      <template v-slot:item.edit="{ item }">
        <v-btn icon @click="editParams(item)"><v-icon>mdi-cog</v-icon></v-btn>
      </template>
      <template v-slot:item.processing="{ item }">
        <v-btn icon v-if="isProcessing(item.setIsInfo)" @click="showProcessing(item)"><v-icon>mdi-information</v-icon></v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="edit" max-width="500">
      <v-card v-if="edit">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            공회전 파라미터 편집
          </v-toolbar-title>
        </v-toolbar>
        <v-form ref="form" @submit.prevent="submit">
          <v-container>
            <v-row>
              <v-col cols="12">
                {{ editedDevice.plateNo }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  label="공회전시간 설정"
                  v-model="form.idleTimeLimit"
                  suffix="초"
                  type="number"
                  hint="0-999"
                  :rules="[v => (!!v && v >= 0 && v <= 999) || '0-999']"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="배터리전압 설정"
                  v-model="form.batVoltLimit"
                  suffix="V"
                  type="number"
                  hint="100-300"
                  :rules="[v => (!!v && v >= 100 && v <= 300) || '100-300']"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="냉각수온도 설정"
                  v-model="form.coolTempLimit"
                  suffix="°C"
                  hint="20-99"
                  type="number"
                  :rules="[v => (!!v && v >= 20 && v <= 99) || '20-99']"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="경사각 설정"
                  v-model="form.incLineLimit"
                  suffix="°"
                  hint="0-20"
                  type="number"
                  :rules="[v => (!!v && v >= 0 && v <= 20) || '0-20']"
                ></v-text-field>
              </v-col>
              <template v-if="$store.state.user.lv < 2">
                <v-col cols="6">
                  <v-select
                    label="주차브레이크 모드"
                    v-model="form.pBrakeMode"
                    :items="selections.slice(0, 3)"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    label="공기압력 모드"
                    v-model="form.airPressMode"
                    :items="selections"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    label="중립 모드"
                    v-model="form.nGearMode"
                    :items="selections"
                  ></v-select>
                </v-col>
              </template>
              <v-col cols="12">
                <v-btn color="success" type="submit">설정</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="processingDialog" max-width="500">
      <v-card v-if="processingDialog">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            {{ processing.plateNo }} 진행중
          </v-toolbar-title>
        </v-toolbar>
        <v-container>
          <template v-for="(item) in paramKeys">
            <v-row no-gutters :key="item.key" v-if="processing.setIsInfo.hasOwnProperty(item.key) && item.show">
              <v-col cols="6" class="subtitle-2">{{ item.title }}</v-col>
              <v-col cols="6">
                <span>
                  {{
                    typeof item.transform === 'function'
                    ? item.transform(processing.setIsInfo[item.key])
                    : processing.setIsInfo[item.key]
                  }}
                </span>
                <span v-if="item.suffix">
                  {{ item.suffix }}
                </span>
              </v-col>
            </v-row>
          </template>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="show" max-width="500">
      <v-card v-if="show">
        <v-toolbar color="primary" dark>
          <v-toolbar-title>
            {{ selectedDevice.plateNo }}
          </v-toolbar-title>
        </v-toolbar>
        <v-container>
          <v-row no-gutters v-for="(item, index) in paramKeys" :key="index">
            <template v-if="item.show">
              <v-col cols="6" class="subtitle-2">{{ item.title }}</v-col>
              <v-col cols="6">
                <span>
                  {{
                    typeof item.transform === 'function'
                    ? item.transform(selectedDevice.isInfo[item.key])
                    : selectedDevice.isInfo[item.key]
                  }}
                </span>
                <span v-if="item.suffix">
                  {{ item.suffix }}
                </span>
              </v-col>
            </template>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { getDeviceList, setParams } from '@/api'
import get from 'lodash/get'

export default {
  data () {
    return {
      classes: {
        paramsTitle: 'subtitle-2 black--text',
        paramsValue: 'black--text'
      },
      paramKeys: [
        {
          key: 'idleTimeLimit',
          title: '공회전시간 설정',
          suffix: '초',
          show: true
        },
        {
          key: 'batVoltLimit',
          title: '배터리전압 설정',
          suffix: 'V',
          show: true
        },
        {
          key: 'coolTempLimit',
          title: '냉각수온도 설정',
          suffix: '°C',
          show: true
        },
        {
          key: 'incLineLimit',
          title: '경사각 설정',
          suffix: '°',
          show: true
        },
        {
          key: 'pBrakeMode',
          title: '주차브레이크 모드',
          transform: (v) => ['노말', '인버스', '캔유즈'][v],
          show: this.$store.state.user.lv < 2
        },
        {
          key: 'airPressMode',
          title: '공기압력 모드',
          transform: (v) => ['노말', '인버스', '캔유즈', '낫유즈'][v],
          show: this.$store.state.user.lv < 2
        },
        {
          key: 'nGearMode',
          title: '중립 모드',
          transform: (v) => ['노말', '인버스', '캔유즈', '낫유즈'][v],
          show: this.$store.state.user.lv < 2
        }
      ],
      selections: [
        { text: '노말', value: 0 },
        { text: '인버스', value: 1 },
        { text: '캔유즈', value: 2 },
        { text: '낫유즈', value: 3 }
      ],
      devices: [],
      customFilters: {
        plateNo: '',
        group: ''
      },
      headers: [
        {
          text: '노선',
          value: 'group.name'
        },
        {
          text: '차량번호',
          value: 'plateNo'
        },
        {
          text: '유종',
          value: 'fuelType'
        },
        {
          text: '모뎀번호',
          value: 'modemNo'
        },
        {
          text: '진행중',
          value: 'processing',
          sortable: false
        },
        {
          text: '편집',
          value: 'edit',
          sortable: false
        }
      ],
      loading: false,
      selectedDevice: null,
      editedDevice: null,
      processing: null,
      processingDialog: false,
      show: false,
      edit: false,
      form: {},
      updatedAt: new Date()
    }
  },
  computed: {
    search () {
      return JSON.stringify(this.customFilters)
    },
    groups () {
      return Object.entries(this.items.reduce((groups, device) => {
        if (!groups[device.group._id]) groups[device.group._id] = device.group.name

        return groups
      }, {})).map(([_id, name]) => {
        return {
          text: name,
          value: _id
        }
      })
    },
    items () {
      return this.devices.map(device => {
        const group = {
          _id: get(device, 'group._id', null),
          name: get(device, 'group.name', '미지정')
        }
        const plateNo = get(device, 'info.plateNo', '미지정')
        const modemNo = device.mn
        return {
          _id: device._id,
          fuelType: device.fuelType,
          group,
          plateNo,
          modemNo,
          isInfo: device.isInfo,
          setIsInfo: device.setISG
        }
      })
    }
  },
  created () {
    this.fetchDevices()
  },
  methods: {
    isProcessing (setIsInfo) {
      if (!setIsInfo) return false
      const keys = [
        'idleTimeLimit',
        'batVoltLimit',
        'coolTempLimit',
        'incLineLimit',
        'pBrakeMode',
        'airPressMode',
        'nGearMode'
      ]

      return keys.some(key => setIsInfo.hasOwnProperty(key))
    },
    showParams (item) {
      this.selectedDevice = item
      this.$nextTick(() => {
        this.show = true
      })
    },
    showProcessing (item) {
      this.processing = item
      this.$nextTick(() => {
        this.processingDialog = true
      })
    },
    editParams (item) {
      this.editedDevice = item
      this.form = Object.assign(this.form, item.isInfo)
      this.$nextTick(() => {
        this.edit = true
      })
    },
    async fetchDevices () {
      this.loading = true
      try {
        const query = {
          populate: 'group'
        }
        const { devices } = await getDeviceList(null, query)

        this.devices = devices
        this.updatedAt = new Date()
      } catch (err) {
        console.error(err)
      }
      this.loading = false
    },
    customFilter (value, search, item) {
      const { group = '', plateNo = '' } = JSON.parse(search)

      return value &&
      typeof value === 'string' &&
      (!group || item.group._id === group) &&
      (!plateNo || item.plateNo.indexOf(plateNo) !== -1)
    },
    async submit () {
      if (!this.$refs.form.validate()) return
      const device = this.editedDevice._id
      const body = {}

      body.idleTimeLimit = this.form.idleTimeLimit
      body.batVoltLimit = this.form.batVoltLimit
      body.coolTempLimit = this.form.coolTempLimit
      body.incLineLimit = this.form.incLineLimit
      body.pBrakeMode = this.form.pBrakeMode
      body.airPressMode = this.form.airPressMode
      body.nGearMode = this.form.nGearMode

      try {
        await setParams(device, body)
        alert('성공적으로 요청을 보냈습니다.')
        this.fetchDevices()
        this.edit = false
      } catch (err) {
        alert(err.message)
      }
    }
  }
}
</script>
